import cash from "cash-dom";

(function () {
    "use strict";


    if (cash('#modal-add-min-stock').length) {

        const select_ele = cash('#selected_item')[0];

        function update_count() {
            let item = select_ele.options[select_ele.selectedIndex];
            let ve_count = Number.parseInt(cash('#min_ve_count')[0].value);
            if (Number.isNaN(ve_count)) {
                ve_count = 0
            }
            cash('#min_count_visu')[0].value = ve_count * item.dataset.defaultcount;
            cash('#min_count')[0].value = ve_count * item.dataset.defaultcount;
        }

        function update_item(item) {
            cash('#bulk_item_name')[0].innerHTML = item.text;
        }

        cash('#selected_item').on('change', function (e) {
            let item = select_ele.options[e.target.selectedIndex];
            update_item(item);
            update_count();
        })

        cash('#min_ve_count').on('change', function (e) {
            update_count();
        })

        cash('#min_ve_count').on('input', function (e) {
            update_count();
        })

        // init fields
        update_item(select_ele.options[select_ele.selectedIndex]);
        update_count();

    }

})();
